module.exports = __webpack_public_path__ + "static/2-2f649edd3e59cea0d885b71eb6f26412.png";